'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var validate = function validate(values) {
  var errors = {};

  if (!(0, _get2.default)(values, 'address.en.country_name')) {
    errors.address = 'Required';
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignSearchContainer/validate.js
// module id = 2973
// module chunks = 0